import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SaleTicker, { shouldShowSaleTickerInitially } from './SaleTicker';

export default function Layout({ children, hideFooter = false }) {
  const [tickerVisible, setTickerVisible] = useState(shouldShowSaleTickerInitially);
  const tickerOffset = tickerVisible ? 'var(--sale-ticker-height)' : '0px';

  return (
    <div className="cyber-bg min-h-screen" style={{ '--layout-ticker-offset': tickerOffset }}>
      <SaleTicker onVisibilityChange={setTickerVisible} />
      <Navbar />
      <main className="relative z-10" style={{ paddingTop: 'calc(var(--layout-ticker-offset, 0px) + var(--navbar-height))' }}>{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
